import { Box } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import CustomChip from '../../../../../../shared/components/CustomChip'
import useScreenWidth from '../../../../../../shared/hooks/useScreenWidth'

interface IParentLogsList {
  id: number
  created_by: string
  name: string
  actionId: number
  data: any
  date: string
}

export function ParentLogsTable() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { logs } = useSelector((state: IRootState) => state.log)

  const initialState = {
    columns: {
      columnVisibilityModel: {
        data: !isMobile
      }
    }
  }

  const rows: GridRowsProp<IParentLogsList> = logs.filter((log: IParentLogsList) => [10, 11, 12, 13].includes(log.actionId)) ?? []
  const columns: GridColDef[] = [
    { headerName: 'Encargado', field: 'created_by', flex: 1 },
    {
      headerName: t('action'),
      field: 'name',
      flex: 1,
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={8} height={24} p={1}>
          {[10, 12].includes(params.row.actionId) && <CustomChip type={2} color="primary" label={params.value} />}
          {[11, 13].includes(params.row.actionId) && <CustomChip type={2} color="secondary" label={params.value} />}
        </Box>
      )
    },
    { headerName: t('data'), field: 'data', flex: 1 },
    { headerName: t('date'), field: 'date', flex: 1 }
  ]

  return <DataGrid rows={rows} columns={columns} disableColumnMenu initialState={initialState} />
}
